import axios from "./axios";

const bookingApi = {
  // User endpoints
  listBookings: () => axios.get("/bookings"),
  getUserBookings: () => axios.get("/my-bookings"),
  createBooking: (bookingData) => axios.post("/bookings", bookingData),
  updateBooking: (id, bookingData) => axios.put(`/bookings/${id}`, bookingData),
  cancelBooking: (id) => axios.put(`/my-bookings/${id}/cancel`),
  deleteBooking: (id) => axios.delete(`/bookings/${id}`),

  // Admin endpoints
  createManualBooking: (bookingData) => axios.post("/admin/bookings/manual", bookingData),
  recordPayment: (bookingId, paymentData) => axios.post(`/admin/bookings/${bookingId}/payment`, paymentData),
  getPayments: (bookingId) => axios.get(`/admin/bookings/${bookingId}/payments`),
};

export default bookingApi;
